document.addEventListener('DOMContentLoaded', () => {
  const description = document.getElementById('collection-description');
  const readMoreButton = document.getElementById('read-more-button');

  if (description.scrollHeight == description.clientHeight) {
    readMoreButton.style.display = 'none';
  }

  if (description && readMoreButton) {
    const readMoreText = readMoreButton.dataset.readMore;
    const readLessText = readMoreButton.dataset.readLess;

    readMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (description.classList.contains('collapsed')) {
        description.classList.remove('collapsed');
        readMoreButton.textContent = readLessText;
      } else {
        description.classList.add('collapsed');
        readMoreButton.textContent = readMoreText;
      }
    });
  }
});
